export default class RedeemAccountUtil {

    private static readonly _regexMail = new RegExp("^\\w+.*@.*\\..*$");
    private static readonly _regexCashApp = new RegExp("^\\$(?=.*[A-Za-z])[A-Za-z0-9]{1,19}$");
    public static VerifyEmail(email: string, message: string = ''): boolean {
        if (!email) {
            return false;
        }
        if (email.indexOf(" ") >= 0) {
            return false;
        }
        if (!this._regexMail.test(email)) {
            return false;
        }
        return true;
    }

    public static VerifyCashApp(account: string): boolean {
        if (!account) {
            return false;
        }
        if (account.indexOf(" ") >= 0) {
            return false;
        }
        if (!this._regexCashApp.test(account)) {
            return false;
        }
        return true;
    }

}